import {NgbPopoverConfig} from "@ng-bootstrap/ng-bootstrap";
import {Injectable} from "@angular/core";

@Injectable()
export class AccPopoverConfig extends NgbPopoverConfig {

  constructor() {
    super();
    this.container = 'body';
    this.triggers = 'hover';
  }
}
